class NavbarController {
  /* @ngInject */
  constructor($rootScope, $state, $window, Auth, Session, urls) {
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$window = $window;
    this.Auth = Auth;
    this.Session = Session;
    this.ACCOUNTS_LOGOUT =
      `${urls.ACCOUNTS_APP}/logout?continue=${
      encodeURIComponent('/signin?client_id=mainapp&state=/main/dashboard')}`;
    this.HIRE_APP = urls.HIRE_APP;
    this.PARTNER_APP = urls.PARTNER_APP;
  }

  $onInit() {
    this.user = this.Session.read('userinfo');
    if (!this.user) return;
    this.isRegistered = this.user.client.is_registered;
    this.appLabel = this.user.group_id === 2 ? 'Partner' : 'Hire';
    this.redirectUrl = this.user.group_id === 2 ? this.PARTNER_APP : this.HIRE_APP;
  }

  logout() {
    const location = this.$window.location;

    // Initiate logout
    this
      .Auth
      .logout()
      .then(
        () => (location.href = this.ACCOUNTS_LOGOUT),
        () => (location.href = this.ACCOUNTS_LOGOUT)
      );
  }
}

export default NavbarController;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.controller.js